import { combineReducers } from 'redux';
import langReducer from './langReducer';
import sampleReducer from './sampleReducer';
import pageReducer from './pageReducer';

/*
 * Reducers
 */
const rootReducer = combineReducers ({
    lang: langReducer,
    samples: sampleReducer,
    page: pageReducer
});
export default rootReducer;